import { ReactNode, useState } from 'react';
import { experimentalStyled as styled } from '@material-ui/core/styles';
import { ComponentsLib } from '@payface-frontends-libs/components';
import { PATH_DASHBOARD } from '../routes/paths';
import SidebarConfigComponent from './sidebarConfigComponent';
import { DashboardSidebar } from '../components/dashboard';

const { DashboardNavbar } = ComponentsLib.Layouts.Dashboard;

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')(() => ({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
}));

const MainStyle = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

type DashboardLayoutProps = {
  children?: ReactNode;
};

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const [open, setOpen] = useState(false);

  return (
    <RootStyle>
      <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
      <DashboardSidebar
        dashboardPath={PATH_DASHBOARD}
        dashboardList={<SidebarConfigComponent />}
        isOpenSidebar={open}
        onCloseSidebar={() => setOpen(false)}
      />

      <MainStyle>{children}</MainStyle>
    </RootStyle>
  );
}
